import { Backend } from '@/_axios';

export default {
  list(page) {
    return Backend.get('/notifications/', { params: { page } });
  },
  newNotificationsList() {
    return Backend.get('/notifications/new');
  },
  notificationsReadUpdate(updateType, ids) {
    return Backend.put(`/notifications/mark-as/${updateType}`, { ids: ids });
  },
};
